import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { BUTTON__CONTENT_CLASS } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';

const { colors, fonts, spacing } = dggTheme;

export const heading = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-size: ${pxToRem(24)};
  color: ${colors.neutralWhite};
  margin: ${stack(spacing.md)};
`;

export const subHeading = css`
  font-family: ${fonts.PRIMARY_REGULAR.familyWithFallbacks};
  font-size: ${pxToRem(20)};
  margin: ${stack(spacing.sm)};
  color: ${colors.neutralWhite};
`;

export const form = css`
  font-family: ${fonts.PRIMARY_REGULAR.familyWithFallbacks};
  padding: ${pxToRem(46)} ${pxToRem(spacing.md)};
  text-align: center;
  margin: 0 auto;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      padding: ${pxToRem(34)} ${pxToRem(spacing.md)};
      max-width: ${pxToRem(360)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: ${pxToRem(34)} ${pxToRem(spacing.md)};
      max-width: ${pxToRem(640)};
    `,
  )};
`;

export const formButtons = css`
  > div {
    margin: ${stack(spacing.md)};
  }

  input {
    font-family: ${fonts.PRIMARY_REGULAR.familyWithFallbacks};
  }

  button {
    .${BUTTON__CONTENT_CLASS} {
      font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
    }
    &:hover {
      background-color: ${colors.neutralWhite};
      .${BUTTON__CONTENT_CLASS} {
        color: ${colors.parisM};
      }
    }
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      column-gap: ${pxToRem(spacing.lg)};

      > div {
        flex-grow: 1;
      }
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XS, max: maxBreakpoints.XS },
    css`
      max-width: ${pxToRem(minBreakpoints.XS)};
    `,
  )};
`;

export const privacyPolicy = css`
  font-size: ${pxToRem(12)};
  margin: ${stack(spacing.md)};
  color: ${colors.neutralWhite};
`;
